import React, { Component } from 'react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import FilterModel from '../../data/filter-model';
import ItemModel from '../../data/item-model';
import { default as magnifier } from '../magnifying-glass.svg';
import MainMenuBtn from '../menu-settings/main-menu-btn';
import SideBar from '../side-bar/side-bar';
import RootCategoryItem from './rootCategory-item';
import HCNLoader from '../../helpers/hcn-loader';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getTranslatedText } from '../../helpers/checkTranslations';
import { store } from '../../redux/store';
import SynergyModel from '../../data/synergy-model';
import Config from '../../Config';

const RootCategoryItems = () => {
    const provider = FilterModel.provider;
    const [items, setItems] = useState([]);
    const [searcheditems, setSearchedItems] = useState([]);
    const [synergyItems, setSynergyItems] = useState([]);
    const history = useHistory();
    const dispatch = useDispatch();

    const isSynergyProvider = FilterModel.provider.communicationType === 3;

    const isDineIn = Config.getDineIn();

    useEffect(() => {
        // HCNLoader.show(dispatch);
        ItemModel
            .getRootCategoryItems(FilterModel.providerId)
            .then(res => {
                if (res.length === 0) {
                    history.push('/add-rootCategory-item');
                    return;
                }
                res.sort((a, b) => a.name.localeCompare(b.name));
                setItems(res);
                setSearchedItems(res);
                HCNLoader.hide(dispatch);
            })
            .catch(err => {
                toast(err.message);
                HCNLoader.hide(dispatch);
            });
        return () => setItems([]);
    }, [dispatch, history]);

    const searchItems = ({ target: { value } }) => {
        value
            ? setSearchedItems(
                  items
                      .filter((x) => {
                          let conditionName =
                              x?.name
                                  ?.toLowerCase()
                                  .includes(value.toLowerCase()) || false;

                          let conditionDescription =
                              x?.description
                                  ?.toLowerCase()
                                  .includes(value.toLowerCase()) || false;

                          return conditionName || conditionDescription;
                      })
                      .sort((a, b) => a.name.localeCompare(b.name))
              )
            : setSearchedItems(items.slice());
    };


    useEffect(() => {
            if(isSynergyProvider) {

            SynergyModel.remote_getAll(provider.id, false)
                        .then((response) => {
                            setSynergyItems(response || []);
                            HCNLoader.hide(dispatch);
                        })
                        .catch((error) => {
                            console.log('error 232323', error);
                            toast.error('Error syncing synergy items');
                            HCNLoader.hide(dispatch);
                        });
            }
    }, []);

    return (
        <div className="divider grid-flex">
            <SideBar />
            <div id="page" className="site">
                <div className="main-content">
                    <header className='site-header'>
                        <div className="header-content">
                            <div className="header-left">
                                <h1 className="main-title">
                                    {getTranslatedText('items', store)}
                                </h1>
                                <p className="items-count">{searcheditems.length} {getTranslatedText('rootCategoryItems', store)}</p>
                            </div>
                            <div className="header-actions">
                                <div className="search-bar-container">
                                    <label htmlFor="searchBar" className="screen-reader-text">
                                        {getTranslatedText('searchbar', store)}
                                    </label>
                                    <input 
                                        type="search" 
                                        id="searchBar" 
                                        placeholder="Search items..." 
                                        onChange={searchItems} 
                                        className="modern-search-input"
                                    />
                                    <button className="search-btn flex-center">
                                        <img src={magnifier} alt="search" />
                                    </button>
                                </div>
                                <div className="action-buttons">
                                    <button type="submit" className="btn default-btn primary-btn">
                                        {getTranslatedText('save', store)}
                                    </button>
                                    <MainMenuBtn />
                                </div>
                            </div>
                        </div>
                    </header>
                    <main className="spacing modern-main">
                        <div className="items-container">
                            <div className={`table-header ${isSynergyProvider ? 'has-synergy' : ''} ${isDineIn ? 'has-dinein' : ''}`}>
                                <div className="header-cell image-cell"></div>
                                <div className="header-cell name-cell">
                                    <h3>{getTranslatedText('rootCategoryItems', store)}</h3>
                                </div>
                                {isSynergyProvider && (
                                    <div className="header-cell synergy-cell">
                                        <p>Synergy Task Codes</p>
                                    </div>
                                )}
                                {isDineIn && (
                                    <>
                                        <div className="header-cell filter-cell">
                                            <p>{getTranslatedText('filter', store)}</p>
                                        </div>
                                        <div className="header-cell price-cell">
                                            <p>{getTranslatedText('price', store)}</p>
                                        </div>
                                        <div className="header-cell availability-cell">
                                            <p>{getTranslatedText('availability', store)}</p>
                                        </div>
                                    </>
                                )}
                                <div className="header-cell actions-cell"></div>
                            </div>

                            <div className="items-list">
                                {searcheditems.map((item, index) => (
                                    <RootCategoryItem
                                        key={item.id}
                                        items={items}
                                        setItems={setItems}
                                        setSearchedItems={setSearchedItems}
                                        synergyItems={synergyItems}
                                        item={item}
                                        index={index}
                                    />
                                ))}
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};
export default RootCategoryItems;
